import { render, staticRenderFns } from "./SearchNavItemDate.vue?vue&type=template&id=31e64174&scoped=true"
import script from "./SearchNavItemDate.vue?vue&type=script&lang=js"
export * from "./SearchNavItemDate.vue?vue&type=script&lang=js"
import style0 from "./SearchNavItemDate.vue?vue&type=style&index=0&id=31e64174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e64174",
  null
  
)

export default component.exports